import './App.css';
import Navbar from "./components/Navbar/Navbar";
import Home from './components/Home/Home';
import Project from './components/Project/Project';

import {Route,Switch} from "react-router-dom";
import Package from './components/Package/Package';

import {AnimatePresence } from "framer-motion";

function App() {
  return (
    <div className="App">
          <Navbar/>

        <AnimatePresence>
          <Switch>
              <Route path="/packages" component={Package}></Route>
              <Route path="/projects" component={Project}></Route>
              <Route path="/" component={Home}></Route>
          </Switch>
          </AnimatePresence>

    </div>
  );
}

export default App;
